var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18C14.1421 18 17.5 14.6421 17.5 10.5C17.5 6.35786 14.1421 3 10 3C5.85786 3 2.5 6.35786 2.5 10.5C2.5 14.6421 5.85786 18 10 18Z",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.375V11.75C10.4945 11.75 10.9778 11.6034 11.3889 11.3287C11.8 11.054 12.1205 10.6635 12.3097 10.2067C12.4989 9.7499 12.5484 9.24723 12.452 8.76228C12.3555 8.27732 12.1174 7.83187 11.7678 7.48223C11.4181 7.1326 10.9727 6.8945 10.4877 6.79804C10.0028 6.70157 9.50011 6.75108 9.04329 6.9403C8.58648 7.12952 8.19603 7.44995 7.92133 7.86108C7.64662 8.2722 7.5 8.75555 7.5 9.25",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.6562C10.4315 15.6562 10.7812 15.3065 10.7812 14.875C10.7812 14.4435 10.4315 14.0938 10 14.0938C9.56853 14.0938 9.21875 14.4435 9.21875 14.875C9.21875 15.3065 9.56853 15.6562 10 15.6562Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFaq);
export default __webpack_public_path__ + "static/media/user_faq.9ef51a9367191624911dadec8027dc77.svg";
export { ForwardRef as ReactComponent };